import React from 'react';
import QuestionKnockoutSwitch from './QuestionKnockoutSwitch';
import QuestionNeedReviewSwitch from './QuestionNeedReviewSwitch';

enum FieldType {
  KNOCKOUT = 'knockout',
  IS_PAUSABLE = 'isPausable',
}
type FieldTypeValue = typeof FieldType[keyof typeof FieldType];
type ValueT = Record<FieldType, boolean>;

interface QuestionKnockoutReviewProps {
  value: ValueT | null;
  onChange: (value: ValueT | null) => void;
}
export default function QuestionKnockoutReview({ value, onChange }: QuestionKnockoutReviewProps) {
  const [currentState, setCurrentState] = React.useState<ValueT | null>(null);

  React.useEffect(() => {
    setCurrentState(
      value ?? /* istanbul ignore next */ {
        [FieldType.KNOCKOUT]: false,
        [FieldType.IS_PAUSABLE]: false,
      },
    );
  }, [value]);

  const handleOnChange = React.useCallback(
    (field: FieldTypeValue) => {
      const baseState = currentState ?? /* istanbul ignore next */ {
        [FieldType.KNOCKOUT]: false,
        [FieldType.IS_PAUSABLE]: false,
      };
      const newState = { ...baseState, [field]: !baseState[field] };
      if (field === FieldType.KNOCKOUT) {
        newState[FieldType.IS_PAUSABLE] = false;
      } else {
        newState[FieldType.KNOCKOUT] = false;
      }

      setCurrentState(newState);
      onChange(newState);
    },
    [currentState, onChange],
  );

  return (
    <>
      <QuestionNeedReviewSwitch
        checked={currentState?.[FieldType.IS_PAUSABLE] || false}
        onChange={() => handleOnChange(FieldType.IS_PAUSABLE)}
      />
      <QuestionKnockoutSwitch
        checked={currentState?.[FieldType.KNOCKOUT] || false}
        onChange={() => handleOnChange(FieldType.KNOCKOUT)}
      />
    </>
  );
}
